<template>
  <div>
    <v-list-item @click="toggleMore">
      <v-list-item-avatar>
        <v-icon
          v-text="invoiceModel.status.icon"
          :class="invoiceStatusIconClass"
        />
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title
          v-html="invoiceTitle"
          class="invoice-title"
        />
        <v-list-item-subtitle
          v-text="invoiceModel.status.title"
          :class="invoiceStatusTitleClass"
        />
        <v-list-item-subtitle
          v-if="invoiceModel.description"
          v-text="invoiceModel.description"
          class="invoice-description"
        />
      </v-list-item-content>
      <v-list-item-action class="d-none d-sm-block">
        <v-btn 
          v-if="invoiceContext.allowedConfirm"
          @click="confirm"
          :disabled="process"
          color="primary"
          x-small
          class="invoice-action-button"
        >
          <v-icon
            v-text="invoiceModel.action.icon"
            small
            left
          />
          {{invoiceModel.action.title}}
        </v-btn>
      </v-list-item-action>
      <v-list-item-action>
        <v-btn
          :ripple="false"
          icon
        >
          <v-icon
            v-text="showMoreIcon"
            class="accent--text"
          />
        </v-btn>
      </v-list-item-action>
    </v-list-item>

    <InvoiceListItemInfo 
      v-if="showMore"
      :buyout="buyout"
      :buyout-item="buyoutItem"
      :ccy="ccy"
      :invoice="invoice"
      :invoiceStatus="invoiceModel.status"
      :sourceStatuses="sourceStatuses"
      @show-bills="$emit('show-bills', $event)"
      class="ml-8"
    />

    <v-btn 
      v-if="invoiceContext.allowedConfirm"
      @click="confirm"
      :disabled="process"
      color="primary"
      small
      block
      class="invoice-action-button d-block d-sm-none my-2"
    >
      <v-icon
        v-text="invoiceModel.action.icon"
        small
        left
      />
      {{invoiceModel.action.title}}
    </v-btn>
  </div>
</template>

<script>
import {appStates}   from '@/constants'
import {InvoiceContext, InvoiceModel} from '@/services/invoices'
import InvoiceListItemInfo   from '@/components/InvoiceListItemInfo'

export default {
  name: 'BuyoutItemInfoInvoiceItem',
  components: {InvoiceListItemInfo},
  computed: {
    invoiceTitle: function () {
      let prefix = 'Счет' + (this.idx ? ` #${this.idx}` : '')
      if (this.invoice.amountDiff) {
        prefix += ` на сумму ${this.$root.$options.filters['number'](this.invoice.amount - this.invoice.amountDiff, 2)}
          ${this.ccy} (сумма счета изменена, ранее была ${this.$root.$options.filters['number'](this.invoice.amount, 2)} ${this.ccy})`
      } else {
        prefix += ` на сумму ${this.$root.$options.filters['number'](this.invoice.amount, 2)} ${this.ccy}`
      }
      return prefix
    },
    invoiceStatusIconClass: function () {
      return `white--text ${this.invoiceModel.status.color}`
    },
    invoiceStatusTitleClass: function () {
      return `invoice-status-title ${this.invoiceModel.status.color}--text font-weight-bold`
    },
    showMoreIcon: function () {
      return `mdi-${this.showMore ? 'chevron-up' : 'chevron-down'}`
    },
    invoiceContext: function () {
      return new InvoiceContext(this.buyout, this.buyoutItem, this.invoice)
    },
    invoiceModel: function () {
      return new InvoiceModel(this.ccy, this.invoice, this.invoiceContext)
    }
  },
  data () {
    return {
      process: false,
      showMore: false
    }
  },
  methods: {
    confirm () {
      const params = {sourceId: this.buyout.sourceId, buyoutId: this.buyout.id, invoiceId: this.invoice.id}
      if (this.buyout.pickupPoints.length && (!this.buyoutItem.pickupPointAdmin && !this.buyoutItem.pickupPointCustomer)) {
        this.$router.push({name: appStates.buyoutPickupPointSet.name, params, query: {invoiceId: this.invoice.id}})
      } else if (this.invoiceContext.allowedPay) {
        this.$router.push({name: appStates.buyoutPayment.name, params})
      } else {
        this.$router.push({name: appStates.buyoutPaymentConfirmation.name, params})
      }
    },
    toggleMore () {
      this.showMore = !this.showMore
    }
  },
  props: {
    buyout: {
      type: Object
    },
    buyoutItem: {
      type: Object
    },
    ccy: {
      type: String
    },
    idx: {
      required: true,
      type: Number
    },
    invoice: {
      required: true,
      type: Object
    },
    sourceStatuses: {
      type: Object
    }
  }
}
</script>

<style scoped>
.invoice-action-button {
  width: 205px;
}
.invoice-status-title {
  white-space: initial;
}
.invoice-title {
  white-space: initial;
}
.invoice-description {
  font-size: 12px;
  white-space: initial;
}
</style>